import { execute, addQueryParams } from '@/api/utils'
import { GET } from '@/api/types'

export default {
  list (params = {}) {
    return execute(GET, addQueryParams('companies', params))
  }
}
